<template>
  <BaseAlert class="tw-p-3 tw-mt-2" theme="danger">
    These dates are currently unavailable to book. Please contact your
    administrator to activate a calendar for this period.
  </BaseAlert>
</template>

<script>
import BaseAlert from '@/components/BaseAlert'

export default {
  name: 'CalendarNotSetupError',
  components: {
    BaseAlert,
  },
}
</script>
